import { Selector } from '@ngxs/store';
import { CartStateModel } from './cart-state.model';
import { CartState } from './cart.state';
import { OrderDetails } from '@app/entities/orders/interfaces/order-details';

export class CartSelectors {
  @Selector([CartState])
  static imageDetailsIds(state: CartStateModel): number[] {
    return state.imageDetailsIds;
  }

  @Selector([CartState])
  static hasItemsInCart(state: CartStateModel): boolean {
    return state.imageDetailsIds.length > 0;
  }

  @Selector([CartState])
  static orderDetails(state: CartStateModel): OrderDetails | undefined {
    return state.orderDetails;
  }
}
